define('views/help',['require','views/base/view','text!templates/help.ejs','jscrollbar'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/help.ejs');

        require('jscrollbar');

    var HelpView = View.extend({
        autoRender: true,
        className: 'main-help-content',
        region: 'help',
        template: template,
        events: {
            'click #help-link': 'showHelp',
            'click #close-link': 'closeHelp'
        },
        listen: {
            'afterLoad model': 'afterLoad'
        },

        initialize: function () {
            View.prototype.initialize.apply(this, arguments);
        },

        render: function() {
            View.prototype.render.apply(this, arguments);
            this.$('.scrollbar-macosx').scrollbar();
        },

        showHelp: function(){
            this.$('.help-not-found').addClass('hidden');
            this.$('.help-container').addClass('visible');

            if(!this.model.get('loaded')){
                this.model.load(true);
                this.$('.help-body').addClass('preloader');
            }else{
                this.afterLoad();
            }
        },

        afterLoad: function(){
            this.$('.help-body').removeClass('preloader');

            var title = this.model.get('title');
            var content = this.model.get('content');
            if((title && title.length) || (content && content.length)){
                this.$('.help-title').html(title);
                this.$('.help-content').html(content);
            }else{
                this.$('.help-not-found').removeClass('hidden');
            }

            this.model.set('loaded', true);
        },
        closeHelp: function(){
            this.$('.help-container').removeClass('visible');
        }
    });

    return HelpView;
});

